enum CarryForwardType {
  NO = 'NO',
  YES = 'YES',
  PERMANENT = 'PERMANENT',
}

export default CarryForwardType;
